import { OptionProps } from 'src/components/ButtonDropdown';
import { CampaignDownloadInclude } from 'src/apis/campaign';

export const SEARCH_GROUPS: OptionProps[] = [
  { label: 'By Episode', value: 'episode' },
  { label: 'By Show', value: 'show' },
];

export const CAMPAIGN_ROWS_ALIGNMENT_OPTIONS: OptionProps[] = [
  { label: 'All alignment', value: '' },
  { label: 'Aligned', value: 'aligned' },
  { label: 'Misaligned', value: 'misaligned' },
  { label: 'Matched', value: 'matched' },
  { label: 'Unmatched', value: 'unmatched' },
];

export const CAMPAIGN_ROWS_EPISODE_ALIGNMENT_OPTIONS: OptionProps[] = [
  ...CAMPAIGN_ROWS_ALIGNMENT_OPTIONS,
  { label: 'Unscored', value: 'unscored' },
];

export const SHOW_ONLY_SEARCH_GROUPS: OptionProps[] = [
  { label: 'By Show', value: 'show' },
];

export const CAMPAIGN_DOWNLOAD_INCLUDE_OPTIONS: {
  label: string;
  value: CampaignDownloadInclude | '';
}[] = [
  { label: 'Deliverables', value: '' },
  { label: 'Deliverables + misaligned', value: 'misaligned' },
  { label: 'Deliverables + unmatched', value: 'unmatched' },
  { label: 'Deliverables + not on inclusion list', value: 'inclusion' },
  { label: 'Deliverables + all', value: 'all' },
];
